import IconInformation from '@assets/svg/icons/information.svg'
import { InformationPanelContext } from '@contexts/information-panel'
import { withDisplayName } from '@hocs/with-display-name'
import clsx from 'clsx/lite'
import { graphql } from 'gatsby'
import React, { useCallback, useContext } from 'react'

const ContentfulInformationButton: Utils.EntryFC<
  Queries.ContentfulInformationButtonFragment
> = ({ content, entryInspectorProps, fieldInspectorProps }) => {
  const { setPanel } = useContext(InformationPanelContext)

  const handleClick = useCallback(() => {
    setPanel(content)
  }, [])

  return (
    <button
      {...entryInspectorProps()}
      {...fieldInspectorProps({
        fieldId: 'content',
      })}
      type="button"
      className={clsx(
        'text-100 inline-flex items-center justify-center gap-1.5',
        'text-white-50/70 group-[.is-dark]/theme:text-amplification-black-premium'
      )}
      onClick={handleClick}
    >
      <span className="text-inherit">Voir conditions</span>
      <IconInformation className="stroke-white-50/70 group-[.is-dark]/theme:stroke-black-50/70" />
    </button>
  )
}

export const query = graphql`
  fragment ContentfulInformationButton on ContentfulInformationPanel {
    ...ContentfulEntry
    content {
      rich
      references {
        ...ContentfulExternalLink
        ...ContentfulStaticPageAmplificationLink
        ...ContentfulDeprecatedPageAmplificationLink
        ...ContentfulPDFLink
      }
    }
  }
`

export default withDisplayName(
  ContentfulInformationButton,
  'ContentfulInformationButton'
)
